import { FIELD_KEYS } from "./constants";

let rowIdCounter = 0;

export function createRowId() {
  rowIdCounter += 1;
  return `rdv-bulk-${Date.now()}-${rowIdCounter}`;
}

export function createEmptyRow(seq = 1, overrides = {}) {
  return {
    id: createRowId(),
    seq,
    workplace: "",
    rdvId: null,
    personType: "other",
    personTypeLabel: "비소방",
    porg: "",
    pdept: "",
    prank: "",
    pname: "",
    pphone: "",
    dutyDesc: "",
    fieldStatus: {},
    fieldMessages: {},
    rowStatus: "pending",
    saveStatus: "idle",
    ...overrides,
  };
}

export function reindexRows(rows) {
  return rows.map((row, i) => ({ ...row, seq: i + 1 }));
}

export function fmtPhone(value) {
  const d = String(value || "")
    .replace(/\D/g, "")
    .slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 7) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
}

export function isValidPnumFormat(value) {
  const v = String(value ?? "").trim();
  if (!v) return true;
  return /^\d{3}-\d{4}-\d{4}$/.test(v);
}

export function parsePersonType(label) {
  const s = String(label ?? "").trim();
  if (!s) return "other";
  if (/소방|fire/i.test(s)) return "fire";
  return "other";
}

export function personTypeLabel(type) {
  return type === "fire" ? "소방" : "비소방";
}

export function rowFromExcelArray(arr, seq) {
  const v = (i) => (arr[i] != null ? String(arr[i]).trim() : "");
  const personType = parsePersonType(v(2));
  return createEmptyRow(seq, {
    workplace: v(1),
    personTypeLabel: v(2) || personTypeLabel(personType),
    personType,
    porg: v(3),
    pdept: v(4),
    prank: v(5),
    pname: v(6),
    pphone: fmtPhone(v(7)),
    dutyDesc: v(8),
  });
}

export function updateRowField(row, fieldKey, value) {
  if (!FIELD_KEYS.includes(fieldKey)) return row;
  const next = { ...row, [fieldKey]: value };
  if (fieldKey === "personTypeLabel") {
    next.personType = parsePersonType(value);
  }
  if (fieldKey === "pphone") {
    next.pphone = fmtPhone(value);
  }
  return {
    ...next,
    fieldStatus: { ...row.fieldStatus, [fieldKey]: undefined },
    fieldMessages: { ...row.fieldMessages, [fieldKey]: undefined },
    rowStatus: "pending",
    saveStatus: row.saveStatus === "saved" ? "idle" : row.saveStatus,
  };
}
